<template>
  <div>
<!--    <embed style="position: absolute;top: 0px;left: 0px;width: 100%;height: 100%" src="/static/ly32s.pdf"></embed>-->
  </div>
<!--  <div style="width: 100%;height: 100%;background-image: url('C:\Users\xuxinyu\Desktop\IdeaProject\testweb\src\assets\bj7.jpg');background-size: 100% 100%;background-repeat: no-repeat;"></div>-->
</template>


<script>
import axios from "axios";

export default {
  name: "extension",
  data() {
    return {
      ip: "",
    }
  },
  components: {},
  mounted() {
    axios.get("http://www.tcnanhua.com:5555/test/getIP?name=" + this.$route.query.name)
      .then((resp) => {
        // this.ip = resp.data.data;
        // alert(this.ip);
        let address = this.$route.query.target == "" || this.$route.query.target == null ? "http://www.nanhua.com" : this.$route.query.target;
        window.open(address, "_self");
      });
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Extension.vue